<template>
    <v-card v-bind:class="cardClass" class="pa-0 text-center" flat>
        <div class="text-center">
            <v-avatar
                v-bind:style="style"
                class="align-self-center"
                size="80"
                icon
            >
                <v-icon class="white--text">{{ icon }}</v-icon>
            </v-avatar>
        </div>
        <v-card-title class="justify-center">
            <h3 v-bind:style="textStyle" class="font-weight-light">
                {{ name }}
            </h3>
        </v-card-title>
        <strong v-if="showDiscount && category">
            {{ category.discount_percentage }}% Desconto
        </strong>
        <strong v-if="showCommission && category"
            >{{ category.percent }}% de Comissão</strong
        >
    </v-card>
</template>

<script>
export default {
    props: {
        category: {
            default: undefined,
        },

        cardClass: {
            type: String,
        },

        showCommission: {
            type: Boolean,
            default: false,
        },

        showDiscount: {
            type: Boolean,
            default: false,
        },
    },

    data: () => {
        return {
            default: {
                color: '#605F5E',
                icon: 'mdi-close-octagon',
                name: 'Sem Categoria',
            },
        }
    },

    computed: {
        color() {
            if (!this.category) return this.default.color
            return this.category.badge_color
        },

        icon() {
            if (!this.category) return this.default.icon
            return this.category.badge_icon
        },

        name() {
            if (!this.category) return this.default.name
            return this.category.name
        },

        style() {
            return {
                'background-color': this.color,
                'border-color': this.color,
            }
        },

        textStyle() {
            return {
                color: this.color,
                'caret-color': this.color,
            }
        },
    },
}
</script>

<style></style>
